<script lang="ts">
	import type { ISceneObj } from 'src/types/SceneType';
	import MainStep from './MainStep.svelte';
	import SelectRoomStep from './SelectRoomStep.svelte';
	import ActiveTimeStep from './ActiveTimeStep.svelte';

	export let scene_object: ISceneObj;
	export let allRoomsRefs: { [key: string | number]: HTMLElement } = {};
	export let selectedRoomRef: HTMLElement = null;
	export let stopConfirmationModal = false;
</script>

<div class="configuration-sections">
	<section aria-label="Scene details">
		<MainStep bind:scene_object />
	</section>

	<div class="configuration-divider"></div>

	<section aria-label="Room">
		<SelectRoomStep bind:allRoomsRefs bind:scene_object bind:selectedRef={selectedRoomRef} />
	</section>

	<div class="configuration-divider"></div>

	<section aria-label="Active time">
		<ActiveTimeStep {stopConfirmationModal} bind:scene_object />
	</section>
</div>

<style>
	.configuration-sections {
		display: flex;
		flex-direction: column;
		padding-bottom: 12px;
	}

	.configuration-divider {
		height: 1px;
		margin: 8px 24px;
		background: var(--color-3, rgba(148, 163, 184, 0.24));
	}
</style>
